/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const s = "newMessage.sendButton", e = "newMessage.optionsButton", t = "newMessage.messageInput", a = "avatar.alt", n = "messageList.ariaLabel", o = "aIPrompt.noOutputs", g = {
  [s]: "Send",
  [e]: "Options",
  [t]: "Message",
  [a]: "Avatar",
  [n]: "Message list",
  [o]: "No output from AI available"
};
export {
  o as aIPromptNoOutputs,
  n as ariaLabelMessageList,
  a as avatarAlt,
  g as messages,
  t as newMessageMessageInput,
  e as newMessageOptionsButton,
  s as newMessageSendButton
};
